import { render, staticRenderFns } from "./actionRecordManagement.vue?vue&type=template&id=562f6fe0&scoped=true"
import script from "./actionRecordManagement.vue?vue&type=script&lang=js"
export * from "./actionRecordManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562f6fe0",
  null
  
)

export default component.exports